export default __webpack_public_path__ + "static/media/Compass.e7477088.svg";